import { getCustomerType } from './query-utils';

export default async (actionName, keyValuePairs) => {
  const CustomerType = getCustomerType();
  const Channel = window?.__EXPERIENCE_CONTEXT__?.channel || 'unknown';
  return window?.newrelic?.addPageAction(actionName, { CustomerType, Channel, ...keyValuePairs });
};

const logNewRelicJSError = async (err) => window?.newrelic?.noticeError(err);

export {
  logNewRelicJSError
};
